export default {
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  filterOptions: state => state.filterOptions,
  filterBy: state => state.filterBy,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  techs: state => state.techs,
  currentTech: state => state.currentTech,
  currentTechs: state => state.currentTechs,
  address: state => state.address,
  center: state => state.center,
  schedule: state => state.schedule
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/getters.js